import getCurrentUser from 'app/users/selectors/getCurrentUser';

export default function isCurrentUserAdmin(state) {
  return getCurrentUser(state)?.role === 'admin';
}
